import { FC, PropsWithChildren, useEffect } from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'

export const ReactGAProvider: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    ReactGA.initialize('UA-213891269-1')
  }, [])

  useEffect(() => {
    ReactGA.pageview(location.pathname)
    window.Appcues?.page()
  }, [location.pathname])

  return <>{children}</>
}
